import React from 'react';

import CommonModal from '../../../../../components/common-modal/CommonModal';
import { MEDIA_STUDIO_ASSET_PREVIEW_TYPES } from '../../../../../constants';
import FontPreview from './components/FontPreview';
import ImagePreview from './components/ImagePreview';

import scss from './AssetPreviewModal.module.scss';

function AssetPreviewModal({ asset, onClose }) {
  return (
    <CommonModal isOpen={Boolean(asset)} onClose={onClose} wrapperClassName={scss.modal} isAnimated>
      {asset?.type === MEDIA_STUDIO_ASSET_PREVIEW_TYPES.IMAGE ? <ImagePreview image={asset.item} /> : null}
      {asset?.type === MEDIA_STUDIO_ASSET_PREVIEW_TYPES.FONT ? <FontPreview font={asset.item} /> : null}
    </CommonModal>
  );
}

export default AssetPreviewModal;
